  jQuery(document).ready(function ($) {
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });


    $(document).on('click', '[data-pagination-link]', function(e) {
        e.preventDefault();
        const $button = $(this);
        const nextUrl = $button.attr('href');

        $button.text("Laden...");
        $button.prop('disabled', true);

        $.get(nextUrl, function(response) {
            const $tempDiv = $('<div>').html(response);
            const newProductsHtml = $tempDiv.find('#product-grid').html();
            const $newButton = $tempDiv.find('[data-pagination-link]');
            
            $('ul#product-grid').append(newProductsHtml);
            $button.closest('.show_more_btn').remove(); // remove old button wrapper

            if ($newButton.length) {
                $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
            }
        }).fail(function() {
            console.error('Error loading more products.');
            $button.text("Try again");
            $button.prop('disabled', false);
        });
    });

    function slider_mobile() {
        if($(window).width() <= 949){ 
        
            const $nt_qualitat = $(".sec_was_caluma_nt .page-width.icon-text-wrapper").flickity({
                initialIndex: 2,
                prevNextButtons: false,
                groupCells: false,
                cellAlign: 'center',
                adaptiveHeight: true,
                contain: true,
                autoPlay: 5000,
                pageDots: false,
            });
        }
    }
    $(document).ready(slider_mobile);
    $(window).on('resize', function() {
        slider_mobile();
    });
      $('.footer-block.has-dropdown .footer-block__heading,.espressoclassico_wrap h2').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });

  
});